<header>
  <b>{{ strategy.header | translate }}</b>
</header>

<section class="confirm-form__body">
  <p class="confirm-form__message">{{ strategy.message | translate: messageParams }}</p>

  <div class="confirm-form__actions">
    <button hlmBtn type="button" class="w-full" (click)="onConfirm()">
      {{ strategy.confirmButtonLabel | translate }}
    </button>
    <button hlmBtn variant="secondary" type="button" class="w-full" (click)="onCancel()">
      {{ strategy.cancelButtonLabel | translate }}
    </button>
  </div>
</section>
